// @flow
import { Dispatch } from 'redux';
import InPlayer from '@inplayer-org/inplayer.js';
import { checkCode } from '../utils/api';

type SelectFeeAction = {
    type: string,
    id: number,
};

export const SELECT_FEE: string = 'SELECT_FEE';

export const ACCESS_FEES_REQUEST: string = 'ACCESS_FEES_REQUEST';
export const ACCESS_FEES_SUCCESS: string = 'ACCESS_FEES_SUCCESS';
export const ACCESS_FEES_FAILURE: string = 'ACCESS_FEES_FAILURE';

export const fetchAccessFees = (assetId: number): Function => {
    return async (dispatch: Dispatch, getState: Function) => {
        const accessFees = getState().assets;
        if (accessFees.isFeeFetched) {
            return null;
        }

        dispatch({ type: ACCESS_FEES_REQUEST, data: { assetId } });

        try {
            InPlayer.Asset.getAssetAccessFees(assetId).then(data => {
                if (checkCode(data)) {
                    dispatch({
                        type: ACCESS_FEES_SUCCESS,
                        data: { accessFees: data, id: assetId },
                    });
                } else {
                    dispatch({
                        type: ACCESS_FEES_FAILURE,
                        data: { assetId },
                    });
                }
            });
        } catch (error) {
            dispatch({
                type: ACCESS_FEES_FAILURE,
                data: { assetId },
            });
        }
    };
};

export const selectFee = (id: number): SelectFeeAction => {
    return {
        type: SELECT_FEE,
        id,
    };
};



// WEBPACK FOOTER //
// ./src/actions/accessFees.js